import { theme } from './theme';

export const pageTitle = {
  fontSize: theme.fontSizes.xl,
  fontWeight: 400,
  color: theme.text.primary,
};

export const stepTitle = {
  fontSize: theme.fontSizes.sm,
  fontWeight: 700,
  margin: '0 0 4px 0',
  color: theme.text.primary,
};

export const descriptionText = {
  fontSize: theme.fontSizes.xs,
  fontWeight: 400,
  color: theme.text.primary,
  lineHeight: '16px',
};

export const subtitleText = {
  fontSize: theme.fontSizes.sm,
  color: theme.text.primary,
  margin: '8px 0 0 0',
  '& strong': {
    fontWeight: 600,
  },
};

export const link = {
  color: theme.text.linkBlue,
  textDecoration: 'underline',
  cursor: 'pointer',
  fontWeight: 600,
  '&:hover': {
    filter: 'brightness(90%)',
  },
};

export const linkDiscreet = {
  ...link,
  color: theme.text.link,
};

export const iconContainer = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px',
  backgroundColor: theme.colors.background.icon,
  borderRadius: '3px',
};

export const separator = {
  border: 'none',
  borderTop: `1px solid ${theme.border.light}`,
  margin: '1rem 0',
};